import { dedent } from '@/wpt-lib/utils/stringUtils';

export function conflictOfInterestText(year: number): string[] {
    if (year < 2026)
        return [
            'I understand and have no interest to declare',
            'I understand and have declared my conflicts of interest via the Declaration of Interest form from the Speak Up website.',
        ];
    else
        return [
            'I understand and have no interest to declare. I have completed a Disclosure of Interest Initial Statement that is up to date.',
            'I understand and have declared my conflicts of interest by completing the Declaration of Interest form (also available from the Speak Up website)',
        ];
}

export function conflictOfInterestLinks(year: number): Record<string, string> {
    const links: Record<string, string> = {
        'Speak Up website': 'https://www.uts.edu.au/about/uts-governance/speak-up',
    };

    if (year >= 2026) {
        links['Disclosure of Interest Initial Statement'] =
            'https://utsprodesm.service-now.com/serviceconnect?id=sc_cat_item&table=sc_cat_item&sys_id=665912458750d6d013f90ed90cbb3591&recordUrl=com.glideapp.servicecatalog_cat_item_view.do%3Fv%3D1&sysparm_id=665912458750d6d013f90ed90cbb3591';
        links['Declaration of Interest form'] =
            'https://studentutsedu.sharepoint.com/:w:/s/Corporate-governance/EVF7zknwWHhHnL_ID7_s3O0B4qZYUjCrRj7ZYvszSg-K9w?e=GTGZCO&ovuser=e8911c26-cf9f-4a9c-878e-527807be8791%2CMichael.Diponio%40uts.edu.au&clickparams=eyJBcHBOYW1lIjoiVGVhbXMtRGVza3RvcCIsIkFwcFZlcnNpb24iOiIxNDE1LzI1MDgxNTAwNzE3IiwiSGFzRmVkZXJhdGVkVXNlciI6ZmFsc2V9';
    }

    return links;
}

export const conflictOfInterestHelpText = dedent(
    `UTS is committed to maintaining a culture of integrity and transparency in line with the behavioural standards outlines in the UTS Code of Conduct.
        
        All staff must proactively declare and manage any actual, perceived, or potential conflicts of interest as part of their annual workplanning. The requirements for declaring conflicts of interest are outlined in the Conflict of Interest Disclosure Policy.
        
        I have discussed conflicts of interest with my supervisor and understand the policy requirements and the obligation for continuous disclosure.
        
        If a conflict of interest is identified, the Declaration of Interest form is available from the Speak Up website and must be completed`,
);
